import { handleActions } from "redux-actions";

import {
    clearConfigs,
    getConfigs,
    getConfigsSuccess,
    getConfigsError,
    getConfig,
    getConfigSuccess,
    getConfigError,
    setConfigFormDialog,
    setExtractKeyDialog,
    getConfigExamples,
    getConfigExamplesSuccess,
    extractKeySuccess
} from "modules/PrimaryKey/services/PrimaryKey/actions";

const initialState = {
    isLoading: false,
    isLoadingCount: false,
    count: 0,
    ids: [],
    configs: [],
    selectedConfigs: [],
    createDialog: {
        initialData: null,
        isOpen: false,
        isLoading: false
    },
    extractKeyDialog: {
        initialData: null,
        isOpen: false,
        isLoading: false
    },
    examples: [],
    extractedKeyResponse: "",
    config: null,
};

export const primaryKeyReducer = handleActions(
    {
        [clearConfigs]: () => ({ ...initialState }),
        [getConfigs]: (state) => ({
            ...state,
            ids: [],
            count: 0,
            configs: [],
            selectedConfigs: [],
            isLoading: true
        }),
        [getConfigsSuccess]: (state, { payload }) => ({
            ...state,
            isLoading: false,
            ...payload
        }),
        [getConfigsError]: (state) => ({
            ...state,
            isLoading: false
        }),
        [getConfig]: (state) => ({
            ...state,
            config: null,
        }),
        [getConfigSuccess]: (state, { payload }) => ({
            ...state,
            isLoading: false,
            ...payload
        }),
        [getConfigError]: (state) => ({
            ...state,
            isLoading: false
        }),
        [setConfigFormDialog]: (state, { payload }) => ({
            ...state,
            createDialog: {
                ...initialState.createDialog,
                ...payload
            }
        }),
        [setExtractKeyDialog]: (state, { payload }) => ({
            ...state,
            extractKeyDialog: {
                ...initialState.extractKeyDialog,
                ...payload
            },
            extractedKeyResponse: ""
        }),
        [getConfigExamples]: (state) => ({
            ...state,
            isLoading: false,
        }),
        [getConfigExamplesSuccess]: (state, { payload }) => ({
            ...state,
            isLoading: false,
            ...payload
        }),
        [extractKeySuccess]: (state, { payload }) => ({
            ...state,
            isLoading: false,
            ...payload
        }),
    },
    initialState
);
